<h3>{{Caption()}}</h3>

<DataGridView [DataUrl]="dataurl()" #Grid KeyProperty="key">

</DataGridView>


<floatingButton icon="bi bi-plus" title="Anlegen" (btnClick)="OpenAkteNew()"></floatingButton>
<floatingButton class="fBtn-1" icon="bi bi bi-journal-arrow-down" title="Export Ausgewählte" *ngIf="Status == 40" (btnClick)="Export()"></floatingButton>
<floatingButton class="fBtn-1" icon="bi bi bi-journal-arrow-down" title="Export Ausgewählte" *ngIf="Status == 800" (btnClick)="Export(false)"></floatingButton>
<floatingButton class="fBtn-2" icon="bi bi-file-earmark-arrow-down-fill" title="Partner Export"  *ngIf="Status == 40" (btnClick)="OpenPartnerExport()"></floatingButton>


<ng-template #buttonTemplate let-data>
  <div class="btn btn-sm btn-primary bi bi-pencil-fill" (click)="OpenAkte(data)"></div>
</ng-template>

<ng-template #buttonTemplateIK let-data>
  <div class="btn btn-sm btn-primary bi bi-card-checklist me-1 position-relative" (click)="OpenUserAuftraege(data)"><i class="amountInfo">{{data.anzahlInKlaerung}}</i></div>
  <div class="btn btn-sm btn-primary bi bi-pencil-fill" (click)="OpenAkte(data)"></div>
</ng-template>

<ng-template #buttonTemplateQCCall let-data>
  <div class="btn btn-sm btn-primary bi bi-telephone-fill me-1" (click)="SendAndReloadGet(`/Backend/Api/V2/Status/QCCall/${data.key}`)"></div>
  <div class="btn btn-sm btn-primary bi bi-pencil-fill" (click)="OpenAkte(data)"></div>
</ng-template>

<ng-template #buttonTemplateCall let-data>
  <div class="btn btn-sm btn-primary bi bi-telephone-fill me-1" (click)="SendAndReloadGet(`/WellcomeCall/${data.key}`)"></div>
  <div class="btn btn-sm btn-primary bi bi-pencil-fill" (click)="OpenAkte(data)"></div>
</ng-template>

<ng-template #buttonTemplateLeitstelle let-data>
  <div class="btn btn-sm btn-primary bi bi-calendar-check me-1" (click)="SendAndReloadGet(`/SetASBBestDateToday/${data.key}`)"></div>
  <div class="btn btn-sm btn-primary bi bi-pencil-fill" (click)="OpenAkte(data)"></div>
</ng-template>

<ng-template #LeitstelleDate let-data>
  <Date-Select [Date]="data.vertragAsbBestaetigtAm" (DateChange)="SendAndReloadGet(`/SetASBBestDate/${data.key}/${(getJsonString($event))}`)"></Date-Select>
</ng-template>


<ng-template #buttonTemplateVersand let-data>
  <div class="btn btn-sm btn-primary bi bi-calendar-check me-1" (click)="SendAndReloadGet(`/SetDateToday/${data.key}`)"></div>
  <div class="btn btn-sm btn-primary bi bi-pencil-fill" (click)="OpenAkte(data)"></div>
</ng-template>

<ng-template #VersandCheck let-data>
  <input type="checkbox" #VersandCbx class="form-check VersandCbx" [checked]="this.selectedIDs.find(o => o == data.key)" (change)="addOrRemoveID(data.key)" />
</ng-template>

<ng-template #VersandCheckCaption let-data>
  <div class="btn btn-sm btn-primary bi bi-check2-all btn-xs" style=" width: 150px; height: 40px; " tooltip="Alle Auswählen" (click)="SelectAll()"> Zu Versenden </div>
</ng-template>



<ng-template #VersandDate let-data>
  <Date-Select [Date]="data.vertragGeliefertAm" (DateChange)="SendAndReloadGet(`/SetDate/${data.key}/${(getJsonString($event))}`)"></Date-Select>
</ng-template>
<ng-template #INBRVorhanden let-data>
  <input type="checkbox" class="form-check inbrCbx" [checked]="data.vertragIbn" disabled readonly />
</ng-template>

<ng-template #TrackingStatus let-data>
  <versand-stepper [CurrentStatus]="data.dhlTrackingStatus"></versand-stepper>
</ng-template>

<ng-template #Phone let-data>
  <PhoneCall [number]="data.userPhoneNumber" ></PhoneCall>
</ng-template>

<ng-template #VersandBtn let-data>
  <div class="btn btn-sm btn-primary bi bi-calendar-check me-1" (click)="SendAndReloadGet(`/SetDateToday/${data.key}`)"></div>
  <div class="btn btn-sm btn-primary bi bi-pencil-fill me-1" (click)="OpenAkte(data)"></div>
  <dhl-controlls [IstVersand]="true" [TrackingNumber]="data.versandTracking"  [AuftragKey]="data.versandAuftrag" [DCOAuftragKey]="data.key" [MailAddress]="data.versichertenMail" [ReloadData]="() => triggerReload()"></dhl-controlls>
</ng-template>

<ng-template #RetoureBtn let-data>
  <div class="btn btn-sm btn-primary bi bi-pencil-fill me-1" (click)="OpenAkte(data)"></div>
  <dhl-controlls [IstVersand]="false" [TrackingNumber]="data.retourenTracking" [DCOAuftragKey]="data.key" [AuftragKey]="data.retourenAuftrag" [MailAddress]="data.versichertenMail" [ReloadData]="() => triggerReload()"></dhl-controlls>
</ng-template>
